/**
 * src/components/ui/Input.jsx
 */
export function Input({
  label, value, onChange, placeholder, type = 'text',
  error, disabled, name, required, style: extra = {},
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', ...extra }}>
      {label && (
        <label style={{
          fontSize: 'var(--text-xs)', fontWeight: 'var(--weight-medium)', color: 'var(--color-text-2)',
          fontFamily: 'var(--font-mono)', letterSpacing: '0.06em',
        }}>
          {label}{required && <span style={{ color: 'var(--color-error)' }}> *</span>}
        </label>
      )}
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        style={{
          background: 'var(--color-surface-2)',
          border: `1px solid ${error ? 'var(--color-error)' : 'var(--color-border)'}`,
          borderRadius: 'var(--radius-sm)', padding: 'var(--space-2) var(--space-3)',
          fontSize: 'var(--text-base)', fontFamily: 'var(--font-ui)',
          color: 'var(--color-text)', outline: 'none',
          transition: 'border-color var(--t-base) var(--ease)',
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? 'not-allowed' : 'text',
          width: '100%', boxSizing: 'border-box',
        }}
        onFocus={e => { e.target.style.borderColor = 'var(--color-accent)' }}
        onBlur={e => { e.target.style.borderColor = error ? 'var(--color-error)' : 'var(--color-border)' }}
      />
      {error && (
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--color-error)', fontFamily: 'var(--font-mono)' }}>
          {error}
        </span>
      )}
    </div>
  )
}

/**
 * src/components/ui/Select.jsx (dentro del mismo archivo por simplicidad)
 */
export function Select({ label, value, onChange, options = [], disabled, style: extra = {} }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', ...extra }}>
      {label && (
        <label style={{
          fontSize: 'var(--text-xs)', fontWeight: 'var(--weight-medium)', color: 'var(--color-text-2)',
          fontFamily: 'var(--font-mono)', letterSpacing: '0.06em',
        }}>
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          background: 'var(--color-surface-2)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-sm)', padding: 'var(--space-2) var(--space-3)',
          fontSize: 'var(--text-base)', fontFamily: 'var(--font-ui)',
          color: 'var(--color-text)', outline: 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
          width: '100%', boxSizing: 'border-box',
          ...extra,
        }}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  )
}

/**
 * Toggle switch
 */
export function Toggle({ checked, onChange, label, disabled }) {
  return (
    <label style={{
      display: 'flex', alignItems: 'center', gap: 'var(--space-3)',
      cursor: disabled ? 'not-allowed' : 'pointer',
    }}>
      <div
        onClick={() => !disabled && onChange(!checked)}
        style={{
          width: '38px', height: '20px', borderRadius: 'var(--radius-pill)',
          background: checked ? 'var(--color-accent)' : 'var(--color-border-2)',
          position: 'relative', transition: 'background var(--t-slow) var(--ease)', flexShrink: 0,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <div style={{
          position: 'absolute', top: '3px',
          left: checked ? '21px' : '3px',
          width: '14px', height: '14px',
          background: 'var(--color-surface)', borderRadius: 'var(--radius-pill)',
          transition: 'left var(--t-slow) var(--ease)', boxShadow: 'var(--shadow-control)',
        }} />
      </div>
      {label && (
        <span style={{ fontSize: 'var(--text-base)', color: 'var(--color-text-2)' }}>{label}</span>
      )}
    </label>
  )
}
